<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Acquisitions Editor: Roxane Cerda</p>
<p class="copy">Managing Editor: Liz Aneloski</p>
<p class="copy">Executive Book Editor: Elaine H. Brelsford</p>
<p class="copy">Proofreader: Managed Editing</p>
<p class="copy">Cover Designer: Michael Buckingham</p>
<p class="copy">Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Zinnia Heinzmann</p>
<p class="copy">Production Editors: Jennifer Warren and Alice Mace Nakanishi</p>
<p class="copy">Front cover photography owned by Gately Williams; back cover photography owned by <a href="http://twenty20photos/elements.envato.com" target="_blank">twenty20photos/elements.envato.com</a></p>
<p class="copy">Portrait photography owned by Michael Schlueter</p>
<p class="copyt">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0002_copyright-title.vue?329dd285